import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { OrderService } from "../../shared/services/order.service";
import { Order } from "../../shared/models/order";

@Component({
  selector: 'app-view-order-page',
  templateUrl: './view-order-page.component.html',
  styleUrls: ['./view-order-page.component.css']
})
export class ViewOrderPageComponent implements OnInit {
  private _order:Order;

  constructor(
    private route:ActivatedRoute
    ,private orderService:OrderService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let orderId = +params['id'];
      // TODO: stephen check for Nan
      this.orderService.getOrder(orderId)
        .then((order:Order) => {
          if (order == null) {
            // TODO: stephen handle not found order.
            console.error("Order not found");
          }
          this._order = order;
          console.log("order found: ", this._order);
        })
        .catch((error) => {
          console.error(error);
        })
    });
  }

  get order() {
    return this._order;
  }

}


// WEBPACK FOOTER //
// ./src/app/admin/view-order-page/view-order-page.component.ts